import {App} from 'vue';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import BugsnagPerformance from '@bugsnag/browser-performance';
import ServerConfig from '../config/server';

let bugsnagInitialised = false;

export const initialiseBugsnag = () => {
    if (bugsnagInitialised) {
        return;
    }

    // The bundle bakes env=production into every image; the meta tag carries
    // the environment the server actually runs as. appVersion stays baked —
    // it must match the sourcemaps uploaded for that build.
    const releaseStage =
        document.querySelector('meta[name="app-env"]')?.getAttribute('content') || ServerConfig.env;

    Bugsnag.start({
        apiKey: ServerConfig.bugsnagApi,
        plugins: [new BugsnagPluginVue()],
        releaseStage,
        appVersion: ServerConfig.buildNumber,
        enabledReleaseStages: ['production', 'staging', 'testing', 'local'],
    });

    BugsnagPerformance.start({
        apiKey: ServerConfig.bugsnagApi,
        releaseStage,
        appVersion: ServerConfig.buildNumber,
        enabledReleaseStages: ['production', 'staging', 'testing', 'local'],
    });

    bugsnagInitialised = true;
};

export const connectVue = (app: App) => {
    initialiseBugsnag();

    const plugin = Bugsnag.getPlugin('vue');

    if (plugin) {
        app.use(plugin);
    }
};
